import { LatestBetOrder } from "app/store/slices/game";
import { ILiveBetsItem } from "../types";
import { CurrencySymbol } from "app/types/common";
import { getCurrencyIcon } from "app/utils/help";

export const mutateMessageData = (data: LatestBetOrder, i: number): ILiveBetsItem => {
    const dis = Number(data.out);

    return {
        id: data.orderid,
        key: data.orderid,
        gameId: data.gameid,
        dark: !!(i % 2),
        game: {
            image: data.gamename,
            name: data.gamename,
        },
        player: {
            image: '-',
            name: data.username,
            level: '-'
        },
        wager: {
            value: Number(data.in)?.toFixed(2),
            currency: CurrencySymbol[data.type as keyof typeof CurrencySymbol],
            icon: getCurrencyIcon(data.type),
        },
        multiplier: {
            growth: dis > 0 ? "+" : "-",
            value: data.multiple.toFixed(2),
        },
        payoutCol: {
            value: dis > 0 ? Number(data.out)?.toFixed(2) : '0.00',
            currency: CurrencySymbol[data.type as keyof typeof CurrencySymbol],
            icon: getCurrencyIcon(data.type),
        },
        tokenId: data.type
    }
}